export const getTabsProductsMarketing = async (endpoint, body)=>{
    if (!endpoint) throw new Error('URL needed');
    if (!body) throw new Error('Body needed');
    const reqParams = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-type': 'application/json'
        }
    };
    const response = await fetch(endpoint, reqParams);
    if (!response.ok || response.status !== 200 && response.status !== 204) throw new Error(response.statusText);
    return response.json();
};

//# sourceMappingURL=service.js.map